import React, {useState} from "react";
import {Column, ColumnGrid} from "../ui/spectre/grid";
import translate from "../../../translate";
import Editable from "../ui/editable";
import {Button, ButtonTypes} from "../ui/spectre/buttons";
import {useNavigate} from "../../hooks/useNavigate";
import Sizes from "../ui/spectre/common/sizes";

export default function EnterInviteCode() {
    const [inviteCode, setInviteCode] = useState('');
    const navigate = useNavigate();

    async function validateCode() {
        const cleanedInviteCode = inviteCode.replace(/[^a-zA-Z0-9]/g, '');
        navigate('/groups/join/' + cleanedInviteCode);
    }

    return <ColumnGrid size={Sizes.sm}>
        <Column sizes={[6]}>
            {translate('page/group/join/enter_invite_code')}
        </Column>
        <Column sizes={[6]}>
            <div className={'full-size pr-2'}>
                <Editable value={inviteCode} onChange={setInviteCode} />
            </div>
        </Column>
        <Column sizes={[12]}>
            <div className={'full-size text-center mt-2'}>
                <Button onClick={validateCode} buttonTypes={[ButtonTypes.primary]}>
                    {translate('page/group/join/validate_code')}
                </Button>
            </div>
        </Column>
    </ColumnGrid>
}
